import Resource from './common/resource';

class EmailTemplates extends Resource {
  path = 'messages/templates';
}

export default EmailTemplates;
